import React from 'react';
import "../../styles/chats/message_dropdown.css";
import deleteIcon from "../../images/chats/delete_icon.png";
import reactionIcon from "../../images/chats/reaction_icon.png";

const MessageDropDown = ({onReact, onDelete, isMessageDropDownShow, canDelete}) => {
    return(
        <div className={`message_drop_down_dialog ${isMessageDropDownShow ? "show" : ""}`}>
            <div className="message_drop_down_row_react" onClick={onReact}>
                <img alt='react' className="message_drop_down_icon" src={reactionIcon} />
                <p className="message_drop_down_text">React</p>
            </div>

            <div className={`message_drop_down_divider ${canDelete ? "show" : ""}`}></div>

            <div className={`message_drop_down_row_delete ${canDelete ? "show" : ""}`} onClick={onDelete}>
                <img alt='delete' className="message_drop_down_icon" src={deleteIcon} />
                <p className="message_drop_down_text">Delete</p>
            </div>
        </div>
    );
};

export default MessageDropDown;